import React, {useState, useEffect, useContext} from 'react'

//Components
import Tree from 'components/Tree'
import TOCNode from './TOCNode'

//Context
import { ParentSortContext, NodeInfoContext } from 'context/content-context'

//Styles
import styles from './TOC.module.scss'

//Types
import {EvaluateNode} from 'types/toc'

//Util
import {flatten} from 'util/toc'

//Hooks
import { useIsSmallDevice } from 'hooks'

export interface Props {
  alias?: string
  page: string,
  nodes: any[],
  toggleSidebar?: ()=>void,
  level?: number
}

const getSelected = (nodes: any[], page: string, alias: string | undefined, isSmallDevice:boolean, toggleSidebar?: ()=>void): any => {
  
  let flattenedToc = flatten(nodes)
  let selectedIndex = flattenedToc.findIndex( node => {
    const evalNode = node as EvaluateNode
    return evalNode.file === page && evalNode.docset === alias
  })
  if (selectedIndex > -1) {
    if (isSmallDevice && toggleSidebar) toggleSidebar()

    return flattenedToc[selectedIndex]
  } 
  return flattenedToc[0] 
}

const TOC = ({alias, page, nodes = [], toggleSidebar, level = 1}: Props) => {
  const isSmallDevice = useIsSmallDevice()
  const [selectedNode, setSelectedNode] = useState(getSelected(nodes, page, alias, isSmallDevice))
  const parentSortContext = useContext(ParentSortContext)
  const nodeInfoContext = useContext(NodeInfoContext)
  const count = nodes.length

  let index = 0

  useEffect( () => {
    let selected = getSelected(nodes, page, alias, isSmallDevice, toggleSidebar)
    let evalNode = selected as EvaluateNode

    nodeInfoContext.setNodeInfoContext(evalNode?.embeddedNode || false, evalNode?.parentTitle || '', evalNode?.parentPage || '', evalNode?.parentDocset || '')

    if (evalNode && evalNode.sortChildren) {
      parentSortContext.setParentSortContext(true)
    } else {
      parentSortContext.setParentSortContext(false)
    }

    setSelectedNode(selected)
  } , [alias,page,nodes]) /* eslint-disable-line */

  return (
    <nav className={styles.toc} id="TOC">
      <Tree>
        { nodes.map( n => {
          index = index+1
          return (
            <TOCNode 
              alias={alias} 
              page={page} 
              node={n} 
              level={level}
              index={index} 
              count={count}
              prevKey={level+'-'+index}
              key={level+'-'+index}
              selectedNode={selectedNode} 
              top={true}/>
          )
        }) }
      </Tree>
    </nav>
  )
}


export default TOC